import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

// RTK Query client for the unified "Change Employee Position" Action form
// (thread #1126). Two endpoints on the BFF, both gated server-side to the
// "Change Employee Position" TABC row AND the POSITION_CHANGE_ENABLED flag, so
// the form ships dark: 503 until the flag is on, 403 without the TABC row.
export const positionChangeApi = createApi({
  reducerPath: "positionChangeApi",
  // Transition lists are per-employee and change only on a move; don't cache.
  keepUnusedDataFor: 0,
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Allowed transitions for one employee's current position. Returns
    // [{ id, toPositionName }] — the UI picker's source of truth.
    getPositionChangeOptions: builder.query({
      query: (employeeRecId) => ({
        url: `/position-change/portal/options?employeeRecId=${encodeURIComponent(
          employeeRecId ?? ""
        )}`,
        method: "GET",
      }),
    }),
    // One-shot move. Body: { employeeRecId, transitionId, targetLocationRecId? }.
    // targetLocationRecId is required only for transitions with locationChange
    // "required" (RM → Tech). The BFF validates the transition against the
    // registry, writes MySQL-first, writes back to Airtable, and closes/reopens
    // Employment History; the RM → Tech row delegates to the proven service.
    changeEmployeePosition: builder.mutation({
      query: (body) => ({
        url: "/position-change/portal/change",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetPositionChangeOptionsQuery,
  useChangeEmployeePositionMutation,
} = positionChangeApi;
